import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$db37 from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as cloudinaryRuntime$12ae from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/cloudinary.js'
import * as cloudinary_uploadRuntime$12ae from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/cloudinary.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 600,
    "md": 960,
    "lg": 1280,
    "xl": 1920,
    "xxl": 1536,
    "2xl": 1536,
    "placeholder": 10
  },
  "presets": {
    "hero": {
      "sizes": "xs:100vw sm:100vw md:100vw lg:100vw xl:100vw",
      "modifiers": {
        "quality": "auto",
        "format": "auto",
        "dpr": "auto"
      }
    },
    "og": {
      "sizes": "xs:100vw sm:100vw md:100vw lg:100vw xl:100vw",
      "modifiers": {
        "quality": "auto",
        "format": "auto",
        "dpr": "auto",
        "width": 1280,
        "c": "fill"
      }
    },
    "placeholder": {
      "modifiers": {
        "quality": "auto",
        "format": "auto",
        "dpr": "auto",
        "width": 10
      }
    }
  },
  "provider": "cloudinary",
  "domains": [
    "0.0.0.0",
    "res.cloudinary.com"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$db37, defaults: {} },
  ['cloudinary']: { provider: cloudinaryRuntime$12ae, defaults: {"baseURL":"https://res.cloudinary.com/pocketpasta/image/fetch/","options":{"quality":"auto","format":"auto","dpr":"auto"}} },
  ['cloudinary_upload']: { provider: cloudinary_uploadRuntime$12ae, defaults: {"baseURL":"https://res.cloudinary.com/pocketpasta/image/upload/"} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
